import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/leads/RoleHeader'
import RolesTable from '../components/leads/RoleCreate'
import Footer from '../components/shared/Footer'

const CreateRole = () => {
    return (
        <>
            <PageHeader>
            
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <RolesTable />
                </div>
            </div>
            
        </>
    )
}

export default CreateRole